
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { checkUrl } from '../../deployment';

@Injectable({
  providedIn: 'root'
})
export class MyQueriesService {
    constructor(
      private http: HttpClient,
    ) { }


  queryList(){
    return this.http.get(checkUrl()+"/admin/query")
    .pipe((response)=>{
          return response;
    })
  }

  downloadDocument($data: any) {
    return this.http.post(checkUrl()+"/admin/download/document",$data,{ responseType:"blob"  })
    .pipe((response)=>{
      return response;
    })
  }


}



